import Home from '@/views/Home'
import Experts from '@/views/Experts'
import Schedule from '@/views/Schedule'
import Schedule_ from '@/views/Schedule_'
import About from '@/views/About'
import Review from '@/views/Review'
import Example from '@/views/Example'
import Course from '@/views/Course'
import Teacher from '@/views/Teacher'
import Sponsor from '@/views/Sponsor'
import Order from '@/views/Order'
import OrderNew from '@/views/OrderNew'
import Collect from '@/views/Collect'
import Login from '@/views/Login'
import UserCenter from '@/views/UserCenter'
import LiveSchedule from '@/views/LiveSchedule'
import Live from '@/views/Live'
// import Poster from '@/views/Poster'
// import Download from '@/views/Download'

export const routes = [
  // { path: '/', redirect: '/home' },
  { path: '/home', name: 'Home', component: Home, meta: { title: 'MPD技术管理工作坊—改变、专业再探索' } },
  { path: '/experts', name: 'Experts', component: Experts, meta: { title: '演讲嘉宾—MDP工作坊专家客座教练' } },
  { path: '/schedule', name: 'Schedule', component: Schedule, meta: { title: '日程安排—MPD技术管理工作坊' } },
  { path: '/schedule_', name: 'Schedule_', component: Schedule_, meta: { title: '日程安排—MPD技术管理工作坊' } },
  { path: '/about', name: 'About', component: About, meta: { title: '关于MPD技术管理工作坊', keepAlive: true } },
  { path: '/review', name: 'Review', component: Review, meta: { title: '往期回顾—MPD技术管理工作坊' } },
  { path: '/example', name: 'Example', component: Example, meta: { title: '精选案例' } },
  { path: '/course', name: 'Course', component: Course },
  { path: '/teacher', name: 'Teacher', component: Teacher, meta: { title: '讲师介绍' } },
  { path: '/sponsor', name: 'Sponsor', component: Sponsor, meta: { title: '赞助' } },
  { path: '/order_', name: 'Order_', component: Order, meta: { title: '购票' } },
  { path: '/order', name: 'Order', component: OrderNew, meta: { title: '购票' } },
  { path: '/collect', name: 'Collect', component: Collect, meta: { title: '' } },
  { path: '/login', name: 'Login', component: Login, meta: { title: '' } },
  { path: '/user_center', name: 'UserCenter', component: UserCenter, meta: { title: '' } },
  { path: '/live_schedule', name: 'LiveSchedule', component: LiveSchedule, meta: { title: '' } },
  { path: '/live', name: 'Live', component: Live, meta: { title: '' } }
  // { path: '/poster',
  //   name: 'Poster',
  //   component: Poster,
  //   props: route => ({
  //     poster_sid: route.query.sid,
  //     poster_type: route.query.type,
  //     poster_cardid: route.query.cardid,
  //     poster_detailid: route.query.detailid,
  //     poster_id: route.query.id
  //   }),
  //   meta: { title: 'MPD技术管理工作坊', isbase: true }
  // },
  // { path: '/download',
  //   name: 'Download',
  //   component: Download,
  //   props: route => ({
  //     download_url: route.query.url,
  //     download_name: route.query.name
  //   }),
  //   meta: { title: 'MPD技术管理工作坊', isbase: true }
  // }
]



// WEBPACK FOOTER //
// ./src/router/routes.js